// useScrapeMeta.js — Composable para obtener metadata del último scrape
//
// Uso:
//   import { useScrapeMeta } from '@/composables/useScrapeMeta';
//   const { lastScrape, coverage, stores, loading, refresh } = useScrapeMeta();
//
// Cachea resultado por 60 segundos. Solo refetcha si pasó ese tiempo o se llama refresh().

import { ref } from 'vue';
import axios from 'axios';

const API_BASE_URL = 'https://dash-visaovip.kompara.tech/api';

// Estado global
const lastScrape = ref(null);   // ISO string del último scrape
const coverage = ref(null);     // # productos del último scrape
const stores = ref(null);       // # tiendas (de client.json idealmente)
const loading = ref(false);
const lastFetched = ref(0);     // timestamp de último fetch
const CACHE_MS = 60_000;        // 1 minuto

function getAuthHeaders() {
  const token = localStorage.getItem('token_precios');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

async function fetchMeta(force = false) {
  const now = Date.now();
  if (!force && now - lastFetched.value < CACHE_MS && lastScrape.value !== null) {
    return; // cache válido
  }
  loading.value = true;
  try {
    const response = await axios.get(`${API_BASE_URL}/usuarios/admin/scraps-info`, getAuthHeaders());
    const data = response.data;
    const scraps = data.scraps_por_dia || [];
    if (scraps.length > 0) {
      const ultimo = scraps[0];
      lastScrape.value = ultimo.ultimo_scrap || ultimo.primer_scrap;
      coverage.value = ultimo.productos_unicos || ultimo.registros;
    }
    // stores: lo dejamos en null por ahora; podemos enchufar al client.json más adelante.
    lastFetched.value = now;
  } catch (e) {
    console.warn('[useScrapeMeta] fetch failed:', e?.message || e);
  } finally {
    loading.value = false;
  }
}

export function useScrapeMeta() {
  // Auto-fetch al primer uso
  if (lastScrape.value === null && !loading.value) {
    fetchMeta();
  }

  return {
    lastScrape,
    coverage,
    stores,
    loading,
    refresh: () => fetchMeta(true),
  };
}